import React from "react"

import { ApiResponse } from "shared/types/ApiResponse"
import { FilePreview } from "shared/types/File"

import { AttachmentFragment } from "entities/attachments/graphql/fragments.generated"
import { LinkedAttachmentEntity } from "entities/attachments/ui/linked-attachments/types/LinkedAttachmentEntity"

import { ReplaceAttachmentOverlayPayload } from "./ReplaceAttachmentOverlayConnector"
import { ReplaceAttachmentOverlayView } from "./ReplaceAttachmentOverlayView"
import { useReplaceAttachmentOverlayViewModel } from "./model/useReplaceAttachmentOverlayViewModel"

export interface ReplaceAttachmentOverlayModel {
  payload: ReplaceAttachmentOverlayPayload
  linkedEntities: LinkedAttachmentEntity[] | undefined
  newFile: AttachmentFragment | null
  isLoading: boolean
  onUpload: (filePreview: FilePreview) => Promise<ApiResponse<unknown>>
  onConfirm: () => void
  onClose: () => void
}

export const ReplaceAttachmentOverlay = React.memo(
  (props: ReplaceAttachmentOverlayModel) => (
    <ReplaceAttachmentOverlayView
      {...useReplaceAttachmentOverlayViewModel(props)}
    />
  )
)
